import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import userRolesQueryKeys from "../query-keys/role.query-keys";
import { UserRole } from "@prisma/client";

const getUserRoles = async () => {
  const { data } = await privateAxios.get<UserRole[]>("/roles");

  return data;
};

export const useUserRoleQuery = () => {
  return useQuery({
    queryKey: userRolesQueryKeys.me(),
    queryFn: () => getUserRoles(),
  });
};
